import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { socials } from "../../../databases/socials";
import { navItems } from "../../../databases/navItems";
import { SocialMediaIcon } from "../SocialMediaIcon/SocialMediaIcon";
import { Logo } from "./Logo/Logo";
import { Navbar } from "./Navbar/Navbar";

import "./Header.scss";

export const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setMobileMenu(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileMenu ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenu]);

  return (
    <header className={scrolled ? "site-header scrolled" : "site-header"}>
      <div className="site-header-content">
        <Logo />

        <div className="desktop-navigation">
          <Navbar />
        </div>

        <div className="header-right">
          <a
            href="https://www.youtube.com"
            target="_blank"
            rel="noreferrer"
            className="header-watch-btn"
          >
            WATCH
            <span>↗</span>
          </a>

          <button
            className={
              mobileMenu
                ? "mobile-menu-trigger active"
                : "mobile-menu-trigger"
            }
            onClick={() => setMobileMenu((prev) => !prev)}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
          </button>
        </div>
      </div>

      <div
        className={
          mobileMenu ? "mobile-menu-panel open" : "mobile-menu-panel"
        }
      >
        <div className="mobile-menu-inner">
          <div className="mobile-menu-links">
            {navItems.map((item, index) => (
              <a href={item.path} key={index}>
                <small>{String(index + 1).padStart(2, "0")}</small>
                {item.name}
              </a>
            ))}
          </div>

          <div className="mobile-menu-bottom">
            <p>Follow the movement</p>

            <ul>
              {socials.map((social, index) => (
                <li key={index}>
                  <SocialMediaIcon
                    props={{
                      icon: social.icon,
                      link: social.url,
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};